import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, hasError, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        // 16px until sm: — anything smaller makes iOS Safari zoom the page on focus.
        'h-11 w-full rounded-md border bg-parchment-light px-3 text-base text-parchment-ink',
        'sm:h-10 sm:text-sm',
        'placeholder:text-parchment-subtle',
        'transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-parchment-light',
        hasError
          ? 'border-danger focus-visible:ring-danger'
          : 'border-parchment-border focus-visible:ring-accent',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
});
